import _classCallCheck from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
/* eslint-disable  @typescript-eslint/no-unused-vars*/

function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ProgressiveImageBase = /*#__PURE__*/function (_React$Component) {
  _inherits(ProgressiveImageBase, _React$Component);

  var _super = _createSuper(ProgressiveImageBase);

  function ProgressiveImageBase(props) {
    var _this;

    _classCallCheck(this, ProgressiveImageBase);

    _this = _super.call(this, props);

    _define_property(_assertThisInitialized(_this), "image", void 0);

    _define_property(_assertThisInitialized(_this), "loadImage", function (src, srcSetData) {
      // If there is already an image we nullify the onload
      // and onerror props so it does not incorrectly set state
      // when it resolves
      if (_this.image) {
        _this.image.onload = null;
        _this.image.onerror = null;
      }

      var image = new Image();
      _this.image = image;
      image.onload = _this.onLoad;
      image.onerror = _this.onError;
      image.src = src;

      if (srcSetData) {
        image.srcset = srcSetData.srcSet;
        image.sizes = srcSetData.sizes;
      }
    });

    _define_property(_assertThisInitialized(_this), "onLoad", function () {
      // use this.image.src instead of this.props.src to
      // avoid the possibility of props being updated and the
      // new image loading before the new props are available as
      // this.props.
      if (_this.props.delay) {
        _this.setImageWithDelay();
      } else {
        _this.setImage();
      }
    });

    _define_property(_assertThisInitialized(_this), "setImageWithDelay", function () {
      setTimeout(function () {
        _this.setImage();
      }, _this.props.delay);
    });

    _define_property(_assertThisInitialized(_this), "setImage", function () {
      var _this_image, _this_image1, _this_image2;

      _this.setState({
        image: ((_this_image = _this.image) === null || _this_image === void 0 ? void 0 : _this_image.src) || '',
        loading: false,
        srcSetData: {
          srcSet: ((_this_image1 = _this.image) === null || _this_image1 === void 0 ? void 0 : _this_image1.srcset) || '',
          sizes: ((_this_image2 = _this.image) === null || _this_image2 === void 0 ? void 0 : _this_image2.sizes) || ''
        }
      });
    });

    _define_property(_assertThisInitialized(_this), "onError", function (errorEvent) {
      var onError = _this.props.onError;

      if (onError) {
        onError(errorEvent);
      }
    });

    _this.image = undefined;
    _this.state = {
      image: props.placeholder,
      loading: true,
      srcSetData: {
        srcSet: '',
        sizes: ''
      }
    };
    return _this;
  }

  _createClass(ProgressiveImageBase, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          src = _this$props.src,
          srcSetData = _this$props.srcSetData;
      this.loadImage(src, srcSetData);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          src = _this$props2.src,
          placeholder = _this$props2.placeholder,
          srcSetData = _this$props2.srcSetData; // We only invalidate the current image if the src has changed.

      if (src !== prevProps.src) {
        this.initializeState(src, placeholder, srcSetData);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.image) {
        this.image.onload = null;
        this.image.onerror = null;
      }
    }
  }, {
    key: "initializeState",
    value: function initializeState(src, placeholder, srcSetData) {
      var _this2 = this;

      this.setState({
        image: placeholder,
        loading: true
      }, function () {
        _this2.loadImage(src, srcSetData);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          image = _this$state.image,
          loading = _this$state.loading,
          srcSetData = _this$state.srcSetData;
      var children = this.props.children;

      if (!children || typeof children !== 'function') {
        throw new Error("ProgressiveImage requires a function as its only child");
      }

      return children(image, loading, srcSetData);
    }
  }]);

  return ProgressiveImageBase;
}(React.Component);

export { ProgressiveImageBase };